import { render, staticRenderFns } from "./VersionWrap.vue?vue&type=template&id=1c297267&scoped=true"
import script from "./VersionWrap.vue?vue&type=script&lang=js"
export * from "./VersionWrap.vue?vue&type=script&lang=js"
import style0 from "./VersionWrap.vue?vue&type=style&index=0&id=1c297267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c297267",
  null
  
)

export default component.exports